import useWithdraw from '@/use/useWithdraw';

const { translateType, typeClassMap } = useWithdraw();

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    broken: {
      name: '',
      width: '6rem',
      // eslint-disable-next-line
      filter: (val: any) => val ? translateType('BROKEN') : '-',
      class: {
        text(val: any) {
          return val ? typeClassMap('BROKEN') : '';
        },
      },
    },
    material: {
      name: 'ชิ้นส่วน',
      width: '1fr',
      class: {
        cell: 'has-multiselect',
      },
    },
    amount: {
      name: 'ทั้งหมดที่จะคืน',
      width: '7rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    filledAmount: {
      name: 'คืนไปแล้ว',
      width: '5rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    addedAmount: {
      name: 'จำนวนที่คืน',
      width: '8rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
    },
    'bom_item.unit': {
      name: 'หน่วย',
      width: '5rem',
      class: 'text-left',
    },
    lot: {
      name: 'Lot',
      width: '14rem',
      class: {
        cell: 'has-multiselect',
      },
    },
  },
};
